import I18n from 'I18n';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { requestTrial } from '../../../lib/requests';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RequestTrialModal = ({
  alertStore,
  apiName,
  trackingData,
  trialId,
  upgradeConfig,
  onClose
}) => {
  useEffect(() => {
    track('view-upgrade-admin-prompt', Object.assign({}, getTrackingProperties({
      apiName,
      trackingData,
      upgradeConfig,
      sourceKey: 'ADMIN_MODAL'
    }), {
      modalType: 'requestTrial',
      trialId
    }));
    // keep empty dependency array so that this event only fires once, not on every rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = () => {
    requestTrial({
      apiName
    }).then(() => {
      (alertStore !== null && alertStore !== void 0 ? alertStore : FloatingAlertStore).addAlert({
        message: I18n.text('purchaseMotions.requestTrial.modal.success.message'),
        titleText: I18n.text('purchaseMotions.requestTrial.modal.success.titleText'),
        type: 'success'
      });
    }).catch(__error => {
      (alertStore !== null && alertStore !== void 0 ? alertStore : FloatingAlertStore).addAlert({
        message: I18n.text('purchaseMotions.requestTrial.modal.error.message'),
        titleText: I18n.text('purchaseMotions.requestTrial.modal.error.titleText'),
        type: 'danger'
      });
    }).finally(() => {
      onClose();
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    width: 540,
    use: "success",
    "data-selenium": "admin-only-modal",
    "data-test-id": "admin-only-modal-requestTrial",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-unit-test": "admin-modal__title",
          "data-test-id": "admin-modal__title",
          message: "purchaseMotions.requestTrial.modal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        paddingInlineEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-unit-test": "admin-modal__paragraph",
          "data-test-id": "admin-modal__paragraph",
          message: "purchaseMotions.requestTrial.modal.paragraph",
          options: {
            productName: I18n.text(`purchaseMotions.products.${apiName}`)
          }
        })
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(View, {
        "data-selenium": "admin-modal-close-button",
        children: /*#__PURE__*/_jsx(Button, {
          marginInlineStart: "0",
          use: "primary",
          onClick: handleClick,
          "data-test-id": "admin-modal-submit-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-unit-test": "admin-modal__button",
            "data-test-id": "admin-modal__button",
            message: "purchaseMotions.requestTrial.modal.button"
          })
        })
      })
    })]
  });
};